import fiscalInstance from '../instance'

const fetchReports = (page, size, dateFrom, dateTo, zonedDateFrom, zonedDateTo) => {
	return fiscalInstance.get('/cashRegisterClose/reports?page=' + page + '&size=' + size
		+ (dateFrom ? '&dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : '')
		+ (zonedDateFrom ? '&zonedDateFrom=' + zonedDateFrom : '')
		+ (zonedDateTo ? '&zonedDateTo=' + zonedDateTo : '')
	)
}

export default fetchReports
